import clsx from "classnames";
import classes from "./styles.module.scss";
import HeaderTitle from "@/components/HeaderTitle";
import DiscoverScroll from "@/components/DiscoverScroll";
import Body from "@/ui/Body";
import Link from "next/link";
import Button from "../Button";
import Image from "@/ui/Image";
import { useState } from "react";
import Title from "@/ui/Title";

export default function Hero2({ label, body, moreBody, highlight, content, className, link, ctas, image, scroll=true, readMore=true, split=true }) {
  const [showAll, setShowAll] = useState(false);

  function toggleShow() {
    setShowAll(!showAll);
  }

  return (
    <div className={clsx(className, classes.hero2)}>
      <div className={classes.left_section}>
        <div className={classes.title}>
          <div className={classes.highlight}>
            <Title tag="h1" title={highlight || label} variant="quaternary" highlight="true" />
          </div>
          {image ? <Image className={classes.image} img={image} alt={label} size="500x280" /> : <></>}
        </div>
        { (content || body) &&
        <div className={classes.contentCont}>
          <div className={classes.content}>{content}</div>
          <Body body={body} />
          {showAll ? <Body body={moreBody} /> : <></>}
          {
            moreBody &&
            <div className={classes.readMore} onClick={() => toggleShow()}>
              {showAll ? "Show Less -" : "Read More +"}
            </div>
          }
          {
            ctas ? <div className={classes.ctas}>
              {
                ctas.map(cta => {
                  if (!cta.link) return;
                  if (cta.button_text?.toLowerCase() === "upload cv") return;
                  return <Button key={cta.button_text} display={cta.button_text} variant={cta.variant} animation={cta.animation} link={cta.link} className={`font-regular ${cta.variant} ${classes.cta}`}></Button>
                })
              }
            </div> : <></>
          }
        </div>
        } 
      </div>
      { scroll &&
        <div className={classes.right_section}>
            <DiscoverScroll/>
        </div>
      }
    </div>
  );
}

Hero2.defaultProps = {
  className: "",
};
